import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogTitle,
  DialogDescription,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogFooter,
} from '@/components/ui/dialog';
import { useState } from 'react';
import type { Deliverable } from './CreateProjectContext';
import MarkdownEditor from '@/components/MarkdownEditor';

interface AddNotesDialogProps {
  deliverable: Deliverable;
  onUpdate: (updated: Partial<Deliverable>) => void | Promise<void>;
}

export default function AddNotesDialog({
  deliverable,
  onUpdate,
}: AddNotesDialogProps) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState(deliverable.notes || '');

  async function handleSave() {
    const updated = { ...deliverable, notes };
    await onUpdate(updated);
    setOpen(false);
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (next) setNotes(deliverable.notes || '');
        setOpen(next);
      }}
    >
      <DialogTrigger asChild>
        <Button variant={'default'} size={'xs'} className="w-26 cursor-pointer">
          {deliverable.notes ? 'Edit' : 'Add'} Notes
        </Button>
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-6xl h-[80vh] flex flex-col"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{deliverable.notes ? 'Edit' : 'Add'} Video Notes</DialogTitle>
          <DialogDescription>
            Notes can help the editor do their best work.
          </DialogDescription>
        </DialogHeader>
        <MarkdownEditor
          value={notes}
          onChange={setNotes}
          className="flex-1 min-h-0"
          autoFocus
        />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant={'ghost'} className="cursor-pointer">
              Cancel
            </Button>
          </DialogClose>
          <Button onClick={handleSave} className="cursor-pointer">
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
